export const DADOS_EMPRESA_SAVE = "DADOS_EMPRESA_SAVE";
export const DADOS_EMPRESA_LOAD = "DADOS_EMPRESA_LOAD";
export const DADOS_EMPRESA_GET = "DADOS_EMPRESA_GET";
export const DADOS_EMPRESA_SAVE_PAYMENT = "DADOS_EMPRESA_SAVE_PAYMENT";
